<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn depressed color="secondary" small v-on="on">{{$t('newSolution')}}</v-btn>
    </template>
    <v-card>
      <v-tabs fixed-tabs>
        <v-tab left>{{$t("newSolution")}}</v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  dense
                  required
                  outlined
                  :rules="rules($t('name'))"
                  :counter="512"
                  v-model="name"
                  :label="$t('enterTheNameOfYourCustomSolution')"
                ></v-text-field>
                <v-divider></v-divider>
                <v-list>
                  <div class="subtitle-1">{{$t('yourProducts')}}</div>
                  <template v-for="(item, index) in products">
                    <v-chip
                      :key="index"
                      close
                      color="bg-grey"
                      @click:close="remove(item.id)"
                    >{{item.name}}</v-chip>
                  </template>
                </v-list>
                <v-text-field
                  v-model="product"
                  :value="product"
                  outlined
                  class="mt-4"
                  dense
                  :rules="counterRules"
                  :counter="512"
                  item-text="name"
                  :label="$t('enterTheNameOfYourProductAndClickThePlusSignToAddToTheList')"
                  v-on:keyup.enter="add"
                  append-icon="add"
                  @click:append="add"
                ></v-text-field>

                <v-divider></v-divider>
                <v-list>
                  <div class="subtitle-1">{{$t('attachment')}}</div>
                  <template v-for="(item, index) in solutionAttachment">
                    <v-chip
                      :key="index"
                      close
                      color="bg-grey"
                      @click:close="removeAttachment(index)"
                    >{{item.name}}</v-chip>
                  </template>
                </v-list>
                <v-list-item>
                  <label style="cursor: pointer" for="file">
                    <v-icon v-ripple>attach_file</v-icon>
                    {{file != null ? file.name : $t('chooseFile')}}
                  </label>
                  <input
                    @change="changeAttachment"
                    style="display:none"
                    type="file"
                    ref="file"
                    id="file"
                  />
                </v-list-item>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">{{$t('close')}}</v-btn>
        <v-btn color="primary" text @click="save">{{$t('save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import uuid from "uuid";
export default {
  name: "addProductSolution",
  data: () => ({
    show: false,
    dialog: false,
    name: null,
    product: null,
    valid: true,
    products: [],
    items: [],
    search: null,
    file: null,
    solutionAttachment: []
  }),
  methods: {
    addAttachment() {
      this.solutionAttachment.push(this.file);
      this.file = null;
    },
    changeAttachment() {
      this.file = this.$refs.file.files[0];
      this.addAttachment();
    },
    close() {
      this.dialog = false;
    },
    rules(property = this.$t('name')) {
      let rules = [
        v => !!v || `${property} ${this.$t("required")}`,
        v => (v && v.length <= 512) || ""
      ];
      return rules;
    },
    counterRules(){
      return [v => v && v.length <= 50 || ""]
    },
    listRules() {
      if (!this.products.length > 0) {
        return [`${this.$t("name")} ${this.$t("list")}`];
      }
    },
    add() {
      //   if (this.product.id) {
      //     const product = {
      //       id: this.product.id,
      //       name: this.product.name
      //     };
      //     if (!this.products.map(x => x.id).includes(this.product.id))
      //       this.products.push(product);
      //     this.product = null;
      //   } else {
      //     const product = {
      //       id: uuid.v4(),
      //       name: this.product
      //     };
      //     if (!this.products.map(x => x.name).includes(this.product))
      //       this.products.push(product);
      //     this.product = "";
      //   }
      setTimeout(() => {
        if (this.product) {
          if (typeof this.product === "string") {
            this.products.push({
              id: uuid.v4(),
              name: this.product
            });
            this.product = null;
          } else if (typeof this.product === "object") {
            this.products.push({
              id: this.product.id,
              name: this.product.name,
              isPIM: true
            });
            this.product = null;
          }
        }
      }, 10);
    },
    save() {
      if (this.$refs.form.validate()) {
        const newSolution = {
          id: uuid.v4(),
          name: this.name,
          IsSolution: true,
          published: true,
          products: this.products,
          // productAttachments: this.solutionAttachment
        };
        let form = new FormData();
        this.solutionAttachment.forEach(attachment => {
        form.append("productAttachments", attachment);
        });

        form.append("solution",JSON.stringify(newSolution));

        this.$emit("add-solution", form);
        this.name = null;
        this.products = null;
        this.solutionAttachment = null;
        this.close();
      }
    },
    remove(id) {
      this.products = this.products.filter(v => {
        return v.id != id;
      });
    },
    removeAttachment(index) {
      this.solutionAttachment = this.solutionAttachment.filter((v, i) => {
        return i != index;
      });
    }
  },
  watch: {
    search(s) {
      if (s && s.length > 1) {
        this.$http
          .getProducts(true, s)
          .then(res => {
            this.items = res.data;
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/pages/Solutions/AddSolution.vue